import React from 'react'
import { Grid, Card, CardHeader, Avatar, IconButton, CardMedia, CardContent, Typography, CardActions } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import FavoriteIcon from '@material-ui/icons/Favorite'
import ShareIcon from '@material-ui/icons/Share'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

class Projects extends React.Component {

    render() {

        const mobile = window.innerWidth < 400 ? true : false

        const featuredProduct = (
            <Grid item xs={11}>
                <Card onClick={() => { window.open('http://cartatrails.com') }}>
                    <CardHeader
                        title='Carta Trails'
                        subheader='Updated Feb 27, 2019'
                        avatar={<Avatar src='https://i.imgur.com/Z6IZR3S.png' alt='paper airplane' >C</Avatar>}
                        action={<IconButton><MoreVertIcon /></IconButton>}
                    />
                    <CardMedia title='Carta Trails' image='https://i.imgur.com/nP6VcLs.jpg' style={{ height: mobile ? '100px' : '200px', width: mobile ? '100%' : '800px' }} />
                    <CardContent>
                        <span>Explore the wonderous creations flying out of Carta Trails</span>
                    </CardContent>
                    <CardActions>
                        <IconButton>
                            <FavoriteIcon />
                        </IconButton>
                        <IconButton>
                            <ShareIcon />
                        </IconButton>
                        <IconButton style={{ marginLeft: 'auto' }}>
                            <ExpandMoreIcon />
                        </IconButton>
                    </CardActions>
                </Card>
            </Grid>
        )

        const makeProjectCard = cardObj => {
            return (
                <Grid item xs={11} md={5}>
                    <Card style={{ textAlign: 'left' }} onClick={() => { window.open(cardObj.url) }}>
                        <CardHeader
                            title={cardObj.title}
                            subheader={cardObj.subheader}
                            avatar={<Avatar src={cardObj.avatarImg} alt={cardObj.avatarAlt} >C</Avatar>}
                            action={<IconButton><MoreVertIcon /></IconButton>}
                        />
                        <CardMedia title={cardObj.title} image={cardObj.mediaImg} style={{ height: '200px' }} />
                        <CardContent>
                            <Typography>{cardObj.content}</Typography>
                        </CardContent>
                        <CardActions>
                            <IconButton>
                                <FavoriteIcon />
                            </IconButton>
                            <IconButton>
                                <ShareIcon />
                            </IconButton>
                            <IconButton style={{ marginLeft: 'auto' }}>
                                <ExpandMoreIcon />
                            </IconButton>
                        </CardActions>
                    </Card>
                </Grid>
            )
        }

        return (

            <Grid container spacing={16} direction='column' alignItems='center'>

                <Grid item xs={12}>
                    <h3>Featured Project</h3>
                </Grid>

                {featuredProduct}

                <Grid item xs={12}>
                    <h3>Successfully Completed</h3>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} justify='center'>

                        {makeProjectCard({
                            url: 'http://www.alphaqualityinc.com/',
                            title: 'Alpha Quality Inc',
                            subheader: 'Updated March 4, 2019',
                            avatarImg: 'https://i.imgur.com/v77c7EQ.png',
                            avatarAlt: 'cog',
                            mediaImg: 'https://i.imgur.com/9rbzcFE.jpg',
                            content: 'Mission driven by total customer satisfaction by supporting all requirements and expectations in the Quality and Delivery of our services. A leader in inspection and sorting components.',
                        })}

                        {makeProjectCard({
                            url: 'http://arastureunion.com',
                            title: 'Arastu Reunion 2019',
                            subheader: 'Updated March 4, 2019',
                            avatarImg: 'https://i.imgur.com/yJS4h3K.png',
                            avatarAlt: 'paper airplane',
                            mediaImg: 'https://i.imgur.com/roCR4TJ.jpg',
                            content: 'Information about the Arastu Family Reunion upcoming in August 2019',
                        })}

                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <h3>In Development</h3>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} justify='center'>

                        {makeProjectCard({
                            url: 'http://theresplentyofroomatthebottom.com',
                            title: 'Theres Plenty of Room at the Bottom',
                            subheader: 'Updated March 1, 2019',
                            avatarImg: 'https://i.imgur.com/QObjB7b.jpg',
                            avatarAlt: 'nano neuron',
                            mediaImg: 'https://i.imgur.com/ii2QoVe.png',
                            content: 'A simulation of nanotechnology',
                        })}

                        {makeProjectCard({
                            url: 'https://graphql.org/',
                            title: 'GraphQL Demonstration',
                            subheader: 'Updated Feb 7, 2019',
                            avatarImg: 'https://i.imgur.com/PiXjxwQ.png',
                            avatarAlt: 'GraphQL Demonstration',
                            mediaImg: 'https://i.imgur.com/CGLqF6E.png',
                            content: 'GraphQL is a query language for APIs and a runtime for fulfilling queries with existing data.',
                        })}

                        {makeProjectCard({
                            url: 'https://github.com/fractalstrategies/edgar-parser',
                            title: 'EDGAR Parser',
                            subheader: 'Updated Jan 24, 2019',
                            avatarImg: 'https://i.imgur.com/dQFA1fZ.png',
                            avatarAlt: 'SEC Filing',
                            mediaImg: 'https://i.imgur.com/96I2Iju.png',
                            content: 'A Python application to extract data from SEC filings',
                        })}

                    </Grid>
                </Grid>

            </Grid>

        )

    }

}

export default Projects
